import { Box, Typography, styled } from '@mui/material';
import { MerchantLogo } from './MerchantLogo';
import { Footer as CaFooter } from '@chargeafter/ui';
import { useGetMerchantConfigurationOptions } from '../services/configManager';

const StyledMerchantLogo = styled(MerchantLogo)(({ theme }) => ({
  height: theme.spacing(3.5),
}));

const StyledTypography = styled(Typography)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  gap: theme.spacing(1),
}));

const StyledBox = styled(Box)(({ theme }) => ({
  height: theme.spacing(6),
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
}));

const Footer = () => {
  const { displayMerchantLogo } = useGetMerchantConfigurationOptions();

  return (
    <footer>
      <StyledBox>
        <StyledTypography color="textSecondary">
          {displayMerchantLogo && <StyledMerchantLogo />}
          <CaFooter text="Powered & Secured by ChargeAfter" />
        </StyledTypography>
      </StyledBox>
    </footer>
  );
};

export default Footer;
